import { LicensedEstablishmentDetailsDesktop } from 'components/LicensedEstablishmentDetails/LicensedEstablishmentDetailsDesktop'
import { Box, CircularProgress, Divider } from '@mui/material'
import { Page } from 'components/Page'
import { PageHeader } from 'components/Shared/PageHeader'
import { useNavigate, useParams } from 'react-router-dom'
import { getLastUpdated } from 'utils/util'
import { isNil } from 'lodash'
import { useGetLicensedEstablishmentById } from 'hooks/api/useGetLicensedEstablishmentById'
import { useLayout } from 'hooks/useLayout'
import { LicensedEstablishmentDetailsMobile } from 'components/LicensedEstablishmentDetails/LicensedEstablishmentDetailsMobile'
import { useCurrentCorporateAccountStore } from 'stores/useCurrentCorporateAccountStore'
import { useEffect } from 'react'

export const LicensedEstablishmentDetailsPage = () => {
  const { id } = useParams()
  const { isMobile } = useLayout()
  const navigate = useNavigate()
  const selectedCorporateAccountId =
    useCurrentCorporateAccountStore().currentCorporateAccountId
  const licensedEstablishmentById = useGetLicensedEstablishmentById(Number(id))

  useEffect(() => {
    // If the CA is switched and the new CA does not match then navigate back to the list page
    if (
      licensedEstablishmentById.data?.corporateAccountId !== null &&
      licensedEstablishmentById.data?.corporateAccountId !== undefined &&
      licensedEstablishmentById.data?.corporateAccountId !==
        selectedCorporateAccountId
    ) {
      void navigate('/Locations')
    }
  }, [licensedEstablishmentById.data])

  if (licensedEstablishmentById.isPending) {
    return <CircularProgress />
  }

  if (
    licensedEstablishmentById.isError ||
    isNil(licensedEstablishmentById.data)
  ) {
    return <p>An error occurred.</p>
  }

  const licensedEstablishment = licensedEstablishmentById.data

  return (
    <Page
      header={
        <Box>
          <PageHeader
            title={
              licensedEstablishment.standardName ?? 'Licensed Establishment'
            }
            backText="Locations"
            backPath="/Locations"
            isSecondary={true}
            subtitle={getLastUpdated(licensedEstablishment.modifiedOn)}
          />
          <Divider />
        </Box>
      }
    >
      {!isMobile && (
        <LicensedEstablishmentDetailsDesktop
          licensedEstablishment={licensedEstablishment}
        />
      )}
      {isMobile && (
        <LicensedEstablishmentDetailsMobile
          licensedEstablishment={licensedEstablishment}
        />
      )}
    </Page>
  )
}
